import { render, staticRenderFns } from "./rPage.vue?vue&type=template&id=4387f892&scoped=true"
import script from "./rPage.vue?vue&type=script&lang=js"
export * from "./rPage.vue?vue&type=script&lang=js"
import style0 from "./rPage.vue?vue&type=style&index=0&id=4387f892&prod&lang=less&scoped=true"
import style1 from "./rPage.vue?vue&type=style&index=1&id=4387f892&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387f892",
  null
  
)

export default component.exports